import ServicePage from '_modules/service/views/ServicePage.vue';
import ServiceList from '_modules/service/views/ServiceList.vue';
import Service from './Root.vue';


export default {
  path: 'services/',
  component: Service,
  name: 'admin-service',
  redirect: '/services/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-service-list',
      component: ServiceList,
    },
    {
      path: 'novo/',
      name: 'admin-service-new',
      component: ServicePage,
    },
    {
      path: ':serviceId',
      name: 'admin-service-edit',
      component: ServicePage,
    },
  ],
};
